import React from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import * as styles from './BackgroundClose.css';

const cx = classNames.bind(styles);

const BackgroundClose = ({ render, closeModal, isModalOpen }) => {
    const backgroundClickClose = () => {
        closeModal();
    };

    return (
        <section>
            {
                // eslint-disable-next-line jsx-a11y/no-static-element-interactions
            }
            <div className={cx({ backgroundMask: isModalOpen })} onClick={backgroundClickClose} />
            {render(backgroundClickClose)}
        </section>
    );
};

BackgroundClose.defaultProps = {
    render: noop,
    closeModal: noop,
    isModalOpen: false,
};

BackgroundClose.propTypes = {
    render: PropTypes.func,
    closeModal: PropTypes.func.isRequired,
    isModalOpen: PropTypes.bool.isRequired,
};

export default BackgroundClose;
